import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../../../services/apiClient';

export type PromptModel = {
  id: string;
  name: string;
  display_name: string;
  gender?: string;
  min_age?: number;
  max_age?: number;
  ethnicity?: string;
  tags?: string[];
  image_url?: string;
  face_image_public_url?: string;
  character_sheet_public_url?: string;
  prompt_text?: string;
  organization_id?: string | null;
  is_exclusive?: boolean;
  visibility?: 'private' | 'organization' | 'public';
};

type Response = {
  items: PromptModel[];
};

type Filters = {
  gender?: string;
  ethnicity?: string;
  age?: number;
  ids?: string[];
  include_exclusive?: boolean;
  include_global?: boolean;
};

type Options = {
  enabled?: boolean;
};

function buildQuery(filters: Filters): string {
  const params = new URLSearchParams();
  if (filters.gender && filters.gender !== 'none') params.set('gender', filters.gender);
  if (filters.ethnicity && filters.ethnicity !== 'none') params.set('ethnicity', filters.ethnicity);
  if (typeof filters.age === 'number') params.set('age', String(filters.age));
  if (filters.ids?.length) params.set('ids', filters.ids.join(','));
  if (filters.include_exclusive !== undefined) params.set('include_exclusive', String(filters.include_exclusive));
  if (filters.include_global !== undefined) params.set('include_global', String(filters.include_global));
  return params.toString();
}

export function usePromptModels(filters: Filters = {}, options: Options = {}) {
  return useQuery({
    queryKey: ['prompt', 'models', filters],
    queryFn: async () => {
      const query = buildQuery(filters);
      const url = query ? `/generation/models?${query}` : '/generation/models';
      const { data } = await apiClient.get<Response>(url);
      return data.items;
    },
    staleTime: 60_000,
    enabled: options.enabled ?? true,
  });
}

